<template>
  <ul class="app-region">
      <li>
        <el-select v-model="province" placeholder="选择省" class="app-region-item" @change="changeProvince">
            <el-option v-for="item in provinceList" :key="item.lid" :value="item.lid" :label="item.name"></el-option>
        </el-select>
      </li>
      <li>
        <el-select v-model="city" placeholder="选择市" class="app-region-item" @change="changeCity">
            <el-option v-for="item in cityList" :key="item.lid" :value="item.lid" :label="item.name"></el-option>
        </el-select>
      </li>
      <li>
        <el-select v-model="area" placeholder="选择区" class="app-region-item">
            <el-option v-for="item in areaList" :key="item.lid" :value="item.lid" :label="item.name"></el-option>
        </el-select>
      </li>
  </ul>
</template>

<script>
export default {
    props: {
        locale: {
            type: String,
            defalut: ''
        }
    },
    data() {
        return {
            flag: true,
            locationInfo: {},
            province: '',
            city: '',
            area: ''
        };
    },
    computed: {
        provinceList() {
            let provinceKeys = Object.keys(this.locationInfo);
            let locationInfo = this.locationInfo;
            let list = [];
            if (provinceKeys.length) {
                provinceKeys.forEach(province => {
                    list.push(locationInfo[province]);
                });
            }
            return list;
        },
        cityList() {
            let currentProvince = this.province;
            let citys =
                currentProvince && this.locationInfo[currentProvince] && this.locationInfo[currentProvince].city
                    ? this.locationInfo[currentProvince].city
                    : {};
            let cityKeys = Object.keys(citys);
            let list = [];
            if (cityKeys.length) {
                cityKeys.forEach(city => {
                    list.push(citys[city]);
                });
            }
            return list;
        },
        areaList() {
            let currentProvince = this.province;
            let currentCity = this.city;
            let areas =
                currentProvince &&
                currentCity &&
                this.locationInfo[currentProvince] &&
                this.locationInfo[currentProvince].city &&
                this.locationInfo[currentProvince].city[currentCity] &&
                this.locationInfo[currentProvince].city[currentCity].area
                    ? this.locationInfo[currentProvince].city[currentCity].area
                    : {};
            let areaKeys = Object.keys(areas);
            let list = [];
            if (areaKeys.length) {
                areaKeys.forEach(area => {
                    list.push(areas[area]);
                });
            }
            return list;
        },
        localeStr() {
            return this.province + ',' + this.city + ',' + this.area;
        }
    },
    beforeMount() {
        this.initLocation();
    },
    watch: {
        locale(newLocale, oldLocale) {
            if (!oldLocale && newLocale) {
                this.initLocation();
            }
        },
        localeStr(newLocale) {
            this.$emit('changeOrigin', newLocale);
        }
    },
    methods: {
        initLocation() {
            if (this.locale) {
                let that = this;
                let localeArr = this.locale.split(',');
                let province = localeArr[0] === '1' ? '' : +localeArr[0];
                let city = +localeArr[1];
                let area = +localeArr[2];
                this.flag = false;
                this.getLocation(1, 0).then(() => {
                    if (province) {
                        that.province = province;
                        that.getLocation(province, 1).then(() => {
                            if (city) {
                                that.city = city;
                                that.getLocation(city, 2).then(() => {
                                    if (area) {
                                        that.area = area;
                                    }
                                    that.flag = true;
                                });
                            } else {
                                that.flag = true;
                            }
                        });
                    } else {
                        that.flag = true;
                    }
                });
            } else {
                this.getLocation(1, 0);
            }
        },
        getLocation(parentId, type) {
            let currentProvince = this.province;
            if (
                (type === 1 && this.locationInfo[parentId] && this.locationInfo[parentId].city) ||
                (type === 2 &&
                    this.locationInfo[currentProvince] &&
                    this.locationInfo[currentProvince].city[parentId] &&
                    this.locationInfo[currentProvince].city[parentId].area)
            ) {
                return Promise.resolve();
            }
            return this.$http
                .get('/v1/config/location-info', {
                    params: { parentId }
                })
                .then(resp => this.$checkResp(resp, []))
                .then(info => {
                    let infoObj = {};
                    info.forEach(item => {
                        if (!infoObj[item.lid]) {
                            infoObj[item.lid] = item;
                        }
                    });
                    if (type) {
                        if (type === 1) {
                            // 获取市
                            this.locationInfo[parentId] = Object.assign({}, this.locationInfo[parentId], {
                                city: infoObj
                            });
                        } else if (type === 2) {
                            // 获取县区
                            this.locationInfo[currentProvince].city[parentId] = Object.assign(
                                {},
                                this.locationInfo[currentProvince].city[parentId],
                                { area: infoObj }
                            );
                        }
                    } else {
                        // 获取省
                        this.locationInfo = Object.assign({}, this.locationInfo, infoObj);
                    }
                    return true;
                })
                .catch(err => {
                    this.$handleError(err);
                });
        },
        changeProvince(newPro) {
            if (newPro && this.flag) {
                this.city = '';
                this.area = '';
                this.getLocation(newPro, 1);
            }
        },
        changeCity(newCity) {
            if (newCity && this.flag) {
                this.area = '';
                this.getLocation(newCity, 2);
            }
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.app-region {
    li {
        display: inline-block;
    }
}

.app-region-item {
    display: inline-block;
    width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/AppSelectArea.vue